import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-snackbar',
  template: `
    <div class="custom-snackbar">
      <span>{{ data.message }}</span>
      <img [src]="data.imageUrl" [alt]="data.imageAlt" class="snackbar-image">
    </div>
  `,
  styles: [`
    .custom-snackbar {
      display: flex;
      align-items: center;
    }
    .snackbar-image {
      margin-left: 10px;
      max-height: 40px;
    }
  `]
})
export class CustomSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: { message: string; imageUrl: string; imageAlt: string }) {}
}